<script lang="ts" setup>
import { computed } from 'vue';
import { useTransition } from '../shared/composables/transition';
import type { TransitionProps } from '../types';

export type FadeSlideTransitionProps = TransitionProps & {
  direction: keyof typeof directionClasses;
};

const props = defineProps<FadeSlideTransitionProps>();

const directionClasses = {
  up: '[translate:0_1rem]',
  down: '[translate:0_-1rem]',
  left: '[translate:1rem]',
  right: '[translate:-1rem]',
} as const satisfies Record<string, string>;

const { classProps, componentIs, componentProps } = useTransition(
  () => props,
  computed(() => ({
    active: 'motion-safe:transition-[opacity,translate]',
    hidden: ['opacity-0', directionClasses[props.direction]].join(' '),
  })),
);
</script>

<template>
  <component v-bind="{ ...classProps, ...componentProps, ...$attrs }" :is="componentIs">
    <slot></slot>
  </component>
</template>
